import { Box, Card, Divider, Grid, TextField, Typography, CircularProgress, Fade, Grow, useTheme } from '@mui/material'
import { useState,useEffect, useMemo, useRef, useCallback } from 'react'
import { connect } from 'react-redux';
import { ButtonBasic, SelectFilterTicket, SelectFilterStageTicket, CardViewTicket, SelectGrupos, SelectGruposUser, SelectEstadoVencimiento, SelectSubTipoTicket, SelectEstadoSoftland } from '../../components'
import TablaTicketService from '../../services/tablaTicket.service';
import { v4 as uuidv4 } from 'uuid';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import usePermisos from '../../hooks/usePermisos';
import ModalNewTickets from '../../modals/ticket/ModalNewTickets';
import { showModal } from 'react-redux-modal-provider';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const TablaTicketScreen = ({
    ticketrefresh
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const permisos = usePermisos();
    const [isLoading, setIsLoading] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [filtroGeneral, setFiltroGeneral] = useState('grupal'); // Iniciar en grupal
    const [filtroEstadoTk, setFiltroEstadoTk] = useState('todos');
    const [ticketsIndv, setTicketsIndv] = useState([]);
    const [ticketsGrupo, setTicketsGrupo] = useState([]);
    const [ticketsCreados, setTicketsCreados] = useState([]);
    const [tickets, setTickets] = useState([]);
    const [ticketsView, setTicketsView] = useState([]);
    const [ticketsDisplayed, setTicketsDisplayed] = useState([]);
    const [displayCount, setDisplayCount] = useState(20); // Mostrar 20 inicialmente
    const [tkCreatedPage, setTkCreatedPage] = useState(0)
    const [hasMoreCreated, setHasMoreCreated] = useState(true)
    const [textSearch, setTextSearch] = useState('')
    const [selectGrupoId, setSelectGrupoId] = useState(null);
    const [selectSubTipoId, setSelectSubTipoId] = useState(null);
    const [selectSubTipoArr, setSelectSubTipoArr] = useState([]);
    const [selectVencido, setSelectVencido] = useState(null);
    const [selectEstadoSoftland, setSelectEstadoSoftland] = useState(null);
    const observerTarget = useRef(null);
    const parseData = (arrOriginal,tipo,creados = false) => {
        const parseFinal = []
        if(Array.isArray(arrOriginal) && arrOriginal?.length > 0){
            if(creados){
                arrOriginal.forEach((descomp)=>{
                    parseFinal.push({
                        ticket: descomp,
                        clientes: descomp?.clientes || [],
                        tipoTicket: tipo,
                        id_uxt: uuidv4(),
                        nombreCompleto: `#${descomp?.id_tk} - ${descomp?.titulo_tk}`
                    })
                })
            }else{
                arrOriginal.forEach((descomp)=>{
                    parseFinal.push({
                        ...descomp,
                        id_uxt: uuidv4(),
                        nombreCompleto: `#${descomp?.ticket?.id_tk} - ${descomp?.ticket?.titulo_tk}`,
                        tipoTicket: tipo
                    })
                })
            }
            return parseFinal;
        }
    }
    const actualizarIndv = async() =>{
        setIsLoading(true);
        await TablaTicketService.getAll({ consulta: 'individual' })
        .then((response)=>{
            const parse = parseData(response,'individual')
            setTicketsIndv(parse);
        })
        .finally(() => {
            setIsLoading(false);
        })
    }
    const actualizarGrupo = async() =>{
        setIsLoading(true);
        await TablaTicketService.getAllGrupos()
        .then((response)=>{
            const parse = parseData(response,'grupal')
            setTicketsGrupo(parse);
        })
        .finally(() => {
            setIsLoading(false);
            setIsInitialLoad(false);
        })
    }
    const actualizarCreated = async(modal) =>{
        setIsLoading(true);
        await TablaTicketService.getAllCreados({
            page: tkCreatedPage
        })
        .then((response)=>{
            setIsLoading(false)
            if(!modal){
                const parse = parseData(response.content,'creado',true)
                setTicketsCreados((prev) => prev?.concat(parse));
                setHasMoreCreated((tkCreatedPage+1) < response.totalPages);
            }else{
                const parse = parseData(response.content,'creado',true)
                setTicketsCreados(parse);
                setTkCreatedPage(0)
                setHasMoreCreated(response.totalPages > 1)
            }
        })
        .catch(()=>{
            setIsLoading(false)
        })
    }
    const onClickNewTicket = () => {
        showModal(ModalNewTickets,{ onGuardar: actualizarCreated, permisos:permisos });
    }

    // Hook para lazy loading con Intersection Observer
    useEffect(() => {
        const observer = new IntersectionObserver(
            entries => {
                if (entries[0].isIntersecting && displayCount < ticketsView.length) {
                    setDisplayCount(prev => Math.min(prev + 20, ticketsView.length));
                }
            },
            { threshold: 0.1, rootMargin: '100px' }
        );

        if (observerTarget.current) {
            observer.observe(observerTarget.current);
        }

        return () => {
            if (observerTarget.current) {
                observer.unobserve(observerTarget.current);
            }
        };
    }, [displayCount, ticketsView.length]);

    // Actualizar tickets mostrados cuando cambia ticketsView o displayCount
    useEffect(() => {
        setTicketsDisplayed(ticketsView.slice(0, displayCount));
    }, [ticketsView, displayCount]);

    // Resetear displayCount cuando cambia ticketsView
    useEffect(() => {
        setDisplayCount(20);
    }, [ticketsView]);
    useEffect(() => {
        const tkInd = ticketsIndv || [];
        const tkGrup = ticketsGrupo || [];
        const tkCreados = ticketsCreados || [];
        
        // Determinar qué tickets mostrar según el filtro
        let totalTk = [];
        if(filtroGeneral === 'grupal'){
            totalTk = tkGrup;
        } else if(filtroGeneral === 'creado'){
            totalTk = tkCreados;
        } else if(filtroGeneral === 'todos'){
            totalTk = tkGrup?.concat(tkCreados);
        } else {
            totalTk = tkInd?.concat(tkGrup?.concat(tkCreados));
        }
        
        let ticketViewFilter = totalTk;
        if(filtroGeneral !== 'todos' && filtroGeneral !== 'grupal' && filtroGeneral !== 'creado'){
            const filtroAct = ticketViewFilter.filter((tk)=> tk.tipoTicket === filtroGeneral)
            if(filtroGeneral === 'grupal' && selectGrupoId){
                const filtroActGrupoId = filtroAct.filter((tk)=> tk?.ticket?.idGrupo === selectGrupoId)
                ticketViewFilter = filtroActGrupoId;
            }else{
                setSelectGrupoId(null)
                ticketViewFilter = filtroAct;
            }
        }else{
            const arrIdTk = [];
            const arrFilterTk = [];
            totalTk.forEach((tk)=>{
                if(!arrIdTk.includes(tk?.ticket?.id_tk)){
                    arrIdTk.push(tk?.ticket?.id_tk)
                    arrFilterTk.push(tk)
                }
            })
            ticketViewFilter = arrFilterTk;
        }
        if(filtroEstadoTk !== 'todos'){
            if(filtroEstadoTk === 'ABIERTO'){
                const filtroAct = ticketViewFilter?.filter((tk)=> !tk?.ticket?.cerrado_tk)
                const arrIdTk = [];
                const arrFilterTk = [];
                filtroAct.forEach((tk)=>{
                    if(!arrIdTk.includes(tk?.ticket?.id_tk)){
                        arrIdTk.push(tk?.ticket?.id_tk)
                        arrFilterTk.push(tk)
                    }
                })
                ticketViewFilter = filtroAct;
            }else if(filtroEstadoTk === 'CERRADO'){
                const filtroAct = ticketViewFilter?.filter((tk)=> tk?.ticket?.cerrado_tk)
                const arrIdTk = [];
                const arrFilterTk = [];
                filtroAct.forEach((tk)=>{
                    if(!arrIdTk.includes(tk?.ticket?.id_tk)){
                        arrIdTk.push(tk?.ticket?.id_tk)
                        arrFilterTk.push(tk)
                    }
                })
                ticketViewFilter = filtroAct;
            }else{
                const filtroAct = ticketViewFilter.filter((tk)=> tk?.ticket?.estado_tk === filtroEstadoTk)
                ticketViewFilter = filtroAct;
            }
        }else{
            const arrIdTk = [];
            const arrFilterTk = [];
            totalTk.forEach((tk)=>{
                if(!arrIdTk.includes(tk?.ticket?.id_tk)){
                    arrIdTk.push(tk?.ticket?.id_tk)
                    arrFilterTk.push(tk)
                }
            })
            ticketViewFilter = arrFilterTk;
        }
        if((selectVencido === 'VENCIDO' || selectVencido === 'NO VENCIDO')){
            if(selectVencido === 'VENCIDO'){
                ticketViewFilter = ticketViewFilter.filter((etk)=> etk?.ticket?.estadoVencimiento_tk === 'VENCIDO' )
            }else{
                ticketViewFilter = ticketViewFilter.filter((etk)=> etk?.ticket?.estadoVencimiento_tk === 'NO VENCIDO' )
            }
        }
        if(selectSubTipoId){
            ticketViewFilter = ticketViewFilter.filter((etk) => etk?.ticket?.subTipoTicketId_tk === selectSubTipoId);
        }
        if(selectEstadoSoftland ){
            ticketViewFilter = ticketViewFilter.filter((etk) => {
                if(etk?.clientes?.length > 0){
                    return etk?.clientes[0]?.estado === selectEstadoSoftland
                }
            });
        }
        const subTipoHabilitados = [];
        ticketViewFilter?.forEach((tkvf) => {
            subTipoHabilitados.push(tkvf?.ticket?.subTipoTicketId_tk);
        });
        setSelectSubTipoArr(subTipoHabilitados);
        setTickets(totalTk)
        ticketViewFilter?.sort((a, b) => b?.ticket?.id_tk - a?.ticket?.id_tk);
        setTicketsView(ticketViewFilter)
    }, [ticketsIndv, ticketsGrupo, ticketsCreados])

    useEffect(() => {
        if(ticketrefresh?.reloadingInd){
            actualizarIndv();
        }
        if(ticketrefresh?.reloadingGroup){
            actualizarGrupo();
        }
    }, [ticketrefresh])

    useEffect(() => {
        // Solo cargar tickets grupales al inicio
        actualizarGrupo();
    }, [])

    useEffect(() => {
        // Cargar tickets creados solo cuando se necesiten
        if(filtroGeneral === 'creado' || filtroGeneral === 'todos'){
            if(ticketsCreados.length === 0){
                actualizarCreated(true);
            }
        }
    }, [filtroGeneral])

    useEffect(() => {
        if(tkCreatedPage > 0){
            actualizarCreated();
        }
    }, [tkCreatedPage])

    useEffect(() => {
        let ticketViewFilter = tickets;
        // Determinar qué tickets usar según el filtro
        if(filtroGeneral === 'grupal'){
            ticketViewFilter = ticketsGrupo || [];
        } else if(filtroGeneral === 'creado'){
            ticketViewFilter = ticketsCreados || [];
        } else if(filtroGeneral === 'todos'){
            ticketViewFilter = (ticketsGrupo || []).concat(ticketsCreados || []);
        }
        if(filtroGeneral !== 'todos' && filtroGeneral !== 'grupal' && filtroGeneral !== 'creado'){
            const filtroAct = ticketViewFilter.filter((tk)=> tk.tipoTicket === filtroGeneral)
            const arrIdTk = [];
            const arrFilterTk = [];
            filtroAct.forEach((tk)=>{
                if(!arrIdTk.includes(tk?.ticket?.id_tk || tk?.id_tk)){
                    arrIdTk.push(tk?.ticket?.id_tk || tk?.id_tk)
                    arrFilterTk.push(tk)
                }
            })
            ticketViewFilter = arrFilterTk;
        }
        if(filtroGeneral === 'grupal' && selectGrupoId){
            const filtroActGrupoId = ticketViewFilter.filter((tk)=> tk?.ticket?.idGrupo === selectGrupoId)
            ticketViewFilter = filtroActGrupoId;
        }
        // Eliminar duplicados
        if(filtroGeneral === 'todos' || !filtroGeneral){
            const arrIdTk = [];
            const arrFilterTk = [];
            ticketViewFilter.forEach((tk)=>{
                if(!arrIdTk.includes(tk?.ticket?.id_tk)){
                    arrIdTk.push(tk?.ticket?.id_tk)
                    arrFilterTk.push(tk)
                }
            })
            ticketViewFilter = arrFilterTk;
        }
        if(filtroEstadoTk){
            if(filtroEstadoTk !== 'todos'){
                if(filtroEstadoTk === 'ABIERTO'){
                    const filtroAct = ticketViewFilter?.filter((tk)=> !tk?.ticket?.cerrado_tk)
                    const arrIdTk = [];
                    const arrFilterTk = [];
                    filtroAct.forEach((tk)=>{
                        if(!arrIdTk.includes(tk?.ticket?.id_tk)){
                            arrIdTk.push(tk?.ticket?.id_tk)
                            arrFilterTk.push(tk)
                        }
                    })
                    ticketViewFilter = filtroAct;
                }else if(filtroEstadoTk === 'CERRADO'){
                    const filtroAct = ticketViewFilter?.filter((tk)=> tk?.ticket?.cerrado_tk)
                    const arrIdTk = [];
                    const arrFilterTk = [];
                    filtroAct.forEach((tk)=>{
                        if(!arrIdTk.includes(tk?.ticket?.id_tk)){
                            arrIdTk.push(tk?.ticket?.id_tk)
                            arrFilterTk.push(tk)
                        }
                    })
                    ticketViewFilter = filtroAct;
                }else{
                    const filtroAct = ticketViewFilter.filter((tk)=> tk?.ticket?.estado_tk === filtroEstadoTk)
                    const arrIdTk = [];
                    const arrFilterTk = [];
                    filtroAct.forEach((tk)=>{
                        if(!arrIdTk.includes(tk?.ticket?.id_tk)){
                            arrIdTk.push(tk?.ticket?.id_tk)
                            arrFilterTk.push(tk)
                        }
                    })
                    ticketViewFilter = filtroAct;
                }
            }else{
                const arrIdTk = [];
                const arrFilterTk = [];
                ticketViewFilter.forEach((tk)=>{
                    if(!arrIdTk.includes(tk?.ticket?.id_tk)){
                        arrIdTk.push(tk?.ticket?.id_tk)
                        arrFilterTk.push(tk)
                    }
                })
                ticketViewFilter = arrFilterTk;
            }
        }
        if((selectVencido === 'VENCIDO' || selectVencido === 'NO VENCIDO')){
            if(selectVencido === 'VENCIDO'){
                ticketViewFilter = ticketViewFilter.filter((etk)=> etk?.ticket?.estadoVencimiento_tk === 'VENCIDO' )
            }else{
                ticketViewFilter = ticketViewFilter.filter((etk)=> etk?.ticket?.estadoVencimiento_tk === 'NO VENCIDO' )
            }
        }
        if(selectSubTipoId){
            ticketViewFilter = ticketViewFilter.filter((etk) => etk?.ticket?.subTipoTicketId_tk === selectSubTipoId);
        }
        if(selectEstadoSoftland ){
            ticketViewFilter = ticketViewFilter.filter((etk) => {
                if(etk?.clientes?.length > 0){
                    return etk?.clientes[0]?.estado === selectEstadoSoftland
                }
            });
        }
        const subTipoHabilitados = [];
        ticketViewFilter?.forEach((tkvf) => {
            subTipoHabilitados.push(tkvf?.ticket?.subTipoTicketId_tk);
        });
        setSelectSubTipoArr(subTipoHabilitados);
        ticketViewFilter?.sort((a, b) => b?.ticket?.id_tk - a?.ticket?.id_tk);
        setTicketsView(ticketViewFilter)
        setTextSearch('')
    }, [filtroGeneral,filtroEstadoTk,selectGrupoId,selectVencido,selectSubTipoId,selectEstadoSoftland])

    const styleInput = useMemo(() => ({
        '& .MuiInputLabel-root':{
            color: isDarkMode ? '#b0bec5' : '#7f8c8d',
            fontSize: 14,
            marginTop: -0.4
        },
        '& fieldset': {
            borderRadius: 2,
            height: 50,
            border: 1,
            borderColor: isDarkMode ? '#3d4a62' : '#e0e0e0',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                border:1,
                color: isDarkMode ? '#64B5F6' : '#0364ff',
                height: 50,
            },
            '&:hover':{
                border: 0.1,
                borderRadius: 2,
                borderColor: isDarkMode ? '#64B5F6' : '#0364ff',
                height: 45,
            },
            '&.Mui-focused': {
                '&:hover':{
                    border: 0,
                    borderRadius: 2,
                    height: 45,
                }
            },
            color: isDarkMode ? '#e0e0e0' : '#2c3e50',
            height: 45,
            width: {xs:'120%', sm: 350, md: 450}
        }
    }), [isDarkMode])

    const inSearchText = (text) =>{
        if(text?.length > 0){
            // Determinar qué tickets usar según el filtro
            let ticketViewFilter = [];
            if(filtroGeneral === 'grupal'){
                ticketViewFilter = ticketsGrupo || [];
            } else if(filtroGeneral === 'creado'){
                ticketViewFilter = ticketsCreados || [];
            } else if(filtroGeneral === 'todos'){
                ticketViewFilter = (ticketsGrupo || []).concat(ticketsCreados || []);
            } else {
                ticketViewFilter = tickets;
            }
            
            if(filtroGeneral !== 'todos' && filtroGeneral !== 'grupal' && filtroGeneral !== 'creado'){
                const filtroAct = ticketViewFilter?.filter((tk)=> tk.tipoTicket === filtroGeneral)
                const arrIdTk = [];
                const arrFilterTk = [];
                filtroAct.forEach((tk)=>{
                    if(!arrIdTk.includes(tk?.ticket?.id_tk)){
                        arrIdTk.push(tk?.ticket?.id_tk)
                        arrFilterTk.push(tk)
                    }
                })
                ticketViewFilter = arrFilterTk;
            }
            
            if(filtroGeneral === 'grupal' && selectGrupoId){
                const filtroActGrupoId = ticketViewFilter.filter((tk)=> tk?.ticket?.idGrupo === selectGrupoId)
                ticketViewFilter = filtroActGrupoId;
            }
            
            // Eliminar duplicados solo cuando sea 'todos'
            if(filtroGeneral === 'todos'){
                const arrIdTk = [];
                const arrFilterTk = [];
                ticketViewFilter.forEach((tk)=>{
                    if(!arrIdTk.includes(tk?.ticket?.id_tk)){
                        arrIdTk.push(tk?.ticket?.id_tk)
                        arrFilterTk.push(tk)
                    }
                })
                ticketViewFilter = arrFilterTk;
            }
            if(filtroEstadoTk !== 'todos'){
                if(filtroEstadoTk === 'ABIERTO'){
                    const filtroAct = ticketViewFilter?.filter((tk)=> !tk?.ticket?.cerrado_tk)
                    const arrIdTk = [];
                    const arrFilterTk = [];
                    filtroAct.forEach((tk)=>{
                        if(!arrIdTk.includes(tk?.ticket?.id_tk)){
                            arrIdTk.push(tk?.ticket?.id_tk)
                            arrFilterTk.push(tk)
                        }
                    })
                    ticketViewFilter = filtroAct;
                }else if(filtroEstadoTk === 'CERRADO'){
                    const filtroAct = ticketViewFilter?.filter((tk)=> tk?.ticket?.cerrado_tk)
                    const arrIdTk = [];
                    const arrFilterTk = [];
                    filtroAct.forEach((tk)=>{
                        if(!arrIdTk.includes(tk?.ticket?.id_tk)){
                            arrIdTk.push(tk?.ticket?.id_tk)
                            arrFilterTk.push(tk)
                        }
                    })
                    ticketViewFilter = filtroAct;
                }else{
                    const filtroAct = ticketViewFilter?.filter((tk)=> tk?.ticket?.estado_tk === filtroEstadoTk)
                    const arrIdTk = [];
                    const arrFilterTk = [];
                    filtroAct.forEach((tk)=>{
                        if(!arrIdTk.includes(tk?.ticket?.id_tk)){
                            arrIdTk.push(tk?.ticket?.id_tk)
                            arrFilterTk.push(tk)
                        }
                    })
                    ticketViewFilter = filtroAct;
                }
            }else{
                const arrIdTk = [];
                const arrFilterTk = [];
                ticketViewFilter.forEach((tk)=>{
                    if(!arrIdTk.includes(tk?.ticket?.id_tk)){
                        arrIdTk.push(tk?.ticket?.id_tk)
                        arrFilterTk.push(tk)
                    }
                })
                ticketViewFilter = arrFilterTk;
            }
            if((selectVencido === 'VENCIDO' || selectVencido === 'NO VENCIDO')){
                if(selectVencido === 'VENCIDO'){
                    ticketViewFilter = ticketViewFilter.filter((etk)=> etk?.ticket?.estadoVencimiento_tk === 'VENCIDO' )
                }else{
                    ticketViewFilter = ticketViewFilter.filter((etk)=> etk?.ticket?.estadoVencimiento_tk === 'NO VENCIDO' )
                }
            }
            if(selectSubTipoId){
                ticketViewFilter = ticketViewFilter.filter((etk) => etk?.ticket?.subTipoTicketId_tk === selectSubTipoId);
            }
            const subTipoHabilitados = [];
            ticketViewFilter?.forEach((tkvf) => {
                subTipoHabilitados.push(tkvf?.ticket?.subTipoTicketId_tk);
            });
            setSelectSubTipoArr(subTipoHabilitados);
            const filtro = ticketViewFilter?.filter((tkv)=> tkv?.nombreCompleto?.toUpperCase()?.includes(text?.toUpperCase()))
            filtro?.sort((a, b) => b?.ticket?.id_tk - a?.ticket?.id_tk);
            setTicketsView(filtro)
        }else{
            // Determinar qué tickets usar según el filtro
            let ticketViewFilter = [];
            if(filtroGeneral === 'grupal'){
                ticketViewFilter = ticketsGrupo || [];
            } else if(filtroGeneral === 'creado'){
                ticketViewFilter = ticketsCreados || [];
            } else if(filtroGeneral === 'todos'){
                ticketViewFilter = (ticketsGrupo || []).concat(ticketsCreados || []);
            } else {
                ticketViewFilter = tickets;
            }
            
            if(filtroGeneral !== 'todos' && filtroGeneral !== 'grupal' && filtroGeneral !== 'creado'){
                const filtroAct = ticketViewFilter?.filter((tk)=> tk?.tipoTicket === filtroGeneral)
                const arrIdTk = [];
                const arrFilterTk = [];
                filtroAct.forEach((tk)=>{
                    if(!arrIdTk.includes(tk?.ticket?.id_tk)){
                        arrIdTk.push(tk?.ticket?.id_tk)
                        arrFilterTk.push(tk)
                    }
                })
                ticketViewFilter = arrFilterTk;
            }
            
            if(filtroGeneral === 'grupal' && selectGrupoId){
                const filtroActGrupoId = ticketViewFilter.filter((tk)=> tk?.ticket?.idGrupo === selectGrupoId)
                ticketViewFilter = filtroActGrupoId;
            }
            
            // Eliminar duplicados solo cuando sea 'todos'
            if(filtroGeneral === 'todos'){
                const arrIdTk = [];
                const arrFilterTk = [];
                ticketViewFilter.forEach((tk)=>{
                    if(!arrIdTk.includes(tk?.ticket?.id_tk)){
                        arrIdTk.push(tk?.ticket?.id_tk)
                        arrFilterTk.push(tk)
                    }
                })
                ticketViewFilter = arrFilterTk;
            }
            if(filtroEstadoTk !== 'todos'){
                if(filtroEstadoTk === 'ABIERTO'){
                    const filtroAct = ticketViewFilter?.filter((tk)=> !tk?.ticket?.cerrado_tk)
                    const arrIdTk = [];
                    const arrFilterTk = [];
                    filtroAct.forEach((tk)=>{
                        if(!arrIdTk.includes(tk?.ticket?.id_tk)){
                            arrIdTk.push(tk?.ticket?.id_tk)
                            arrFilterTk.push(tk)
                        }
                    })
                    ticketViewFilter = filtroAct;
                }else if(filtroEstadoTk === 'CERRADO'){
                    const filtroAct = ticketViewFilter?.filter((tk)=> tk?.ticket?.cerrado_tk)
                    const arrIdTk = [];
                    const arrFilterTk = [];
                    filtroAct.forEach((tk)=>{
                        if(!arrIdTk.includes(tk?.ticket?.id_tk)){
                            arrIdTk.push(tk?.ticket?.id_tk)
                            arrFilterTk.push(tk)
                        }
                    })
                    ticketViewFilter = filtroAct;
                }else{
                    const filtroAct = ticketViewFilter?.filter((tk)=> tk?.ticket?.estado_tk === filtroEstadoTk)
                    const arrIdTk = [];
                    const arrFilterTk = [];
                    filtroAct.forEach((tk)=>{
                        if(!arrIdTk.includes(tk?.ticket?.id_tk)){
                            arrIdTk.push(tk?.ticket?.id_tk)
                            arrFilterTk.push(tk)
                        }
                    })
                    ticketViewFilter = filtroAct;
                }
            }else{
                const arrIdTk = [];
                const arrFilterTk = [];
                ticketViewFilter.forEach((tk)=>{
                    if(!arrIdTk.includes(tk?.ticket?.id_tk)){
                        arrIdTk.push(tk?.ticket?.id_tk)
                        arrFilterTk.push(tk)
                    }
                })
                ticketViewFilter = arrFilterTk;
            }
            if((selectVencido === 'VENCIDO' || selectVencido === 'NO VENCIDO')){
                if(selectVencido === 'VENCIDO'){
                    ticketViewFilter = ticketViewFilter.filter((etk)=> etk?.ticket?.estadoVencimiento_tk === 'VENCIDO' )
                }else{
                    ticketViewFilter = ticketViewFilter.filter((etk)=> etk?.ticket?.estadoVencimiento_tk === 'NO VENCIDO' )
                }
            }
            if(selectSubTipoId){
                ticketViewFilter = ticketViewFilter.filter((etk) => etk?.ticket?.subTipoTicketId_tk === selectSubTipoId);
            }
            const subTipoHabilitados = [];
            ticketViewFilter?.forEach((tkvf) => {
                subTipoHabilitados.push(tkvf?.ticket?.subTipoTicketId_tk);
            });
            setSelectSubTipoArr(subTipoHabilitados);
            ticketViewFilter?.sort((a, b) => b?.ticket?.id_tk - a?.ticket?.id_tk);
            setTicketsView(ticketViewFilter)
        }
        setTextSearch(text)
    }
    useEffect(() => {
        document.title = `Tabla Tickets`;
    }, [])
    return (
        <Box sx={{width:'100%',height: '100%',overflow:'auto'}} className='side'>
            <Grid container p={3} spacing={2}>
                <Grid item xs={12} md={6}>
                    <Box sx={{
                        animation: 'fadeInDown 0.6s ease-out',
                        '@keyframes fadeInDown': {
                            '0%': {
                                opacity: 0,
                                transform: 'translateY(-20px)'
                            },
                            '100%': {
                                opacity: 1,
                                transform: 'translateY(0)'
                            }
                        }
                    }}>
                        <Typography 
                            className="text-gray-900 font-bold" 
                            variant="h2"
                            sx={{
                                background: isDarkMode 
                                    ? 'linear-gradient(135deg, #64B5F6 0%, #42A5F5 100%)'
                                    : 'linear-gradient(135deg, #2c3e50 0%, #0364ff 100%)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                mb: 1
                            }}
                        >
                            Tabla de Tickets
                        </Typography>
                        <Box sx={{
                            width: '60px',
                            height: '4px',
                            background: 'linear-gradient(90deg, #0364ff 0%, #4a90e2 100%)',
                            borderRadius: '10px',
                            animation: 'expandWidth 0.8s ease-out',
                            '@keyframes expandWidth': {
                                '0%': { width: '0px' },
                                '100%': { width: '60px' }
                            }
                        }} />
                    </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: {xs: 'center', sm: 'flex-end'},
                        animation: 'fadeIn 0.8s ease-out',
                        '@keyframes fadeIn': {
                            '0%': { opacity: 0 },
                            '100%': { opacity: 1 }
                        }
                    }}>
                        <ButtonBasic
                            iconStart={<AddIcon sx={{color: '#fff'}} />}
                            textButton="Nuevo Ticket"
                            sx={{
                                width: {xs: '100%', sm: 180},
                                height: 42,
                                color: '#fff',
                                borderRadius: '12px',
                                fontWeight: 600,
                                fontSize: 14,
                                textTransform: 'none',
                                boxShadow: '0 4px 14px rgba(3, 100, 255, 0.3)',
                                transition: 'all 0.3s ease',
                            }}
                            onClick={()=>onClickNewTicket()}
                            variant='wk'
                            color='nextStep'
                        />
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Card sx={{
                        background: isDarkMode 
                            ? 'linear-gradient(135deg, #1F2A40 0%, #2d3a52 100%)'
                            : 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                        borderRadius: '16px',
                        boxShadow: isDarkMode 
                            ? '0 4px 20px rgba(0,0,0,0.3)'
                            : '0 4px 20px rgba(0,0,0,0.06)',
                        border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e0e0e0',
                        padding: 3,
                        animation: 'fadeInUp 0.6s ease-out',
                        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                        '@keyframes fadeInUp': {
                            '0%': {
                                opacity: 0,
                                transform: 'translateY(20px)'
                            },
                            '100%': {
                                opacity: 1,
                                transform: 'translateY(0)'
                            }
                        }
                    }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={4} lg={2}>
                                <Box sx={{
                                    width: '100%',
                                    transition: 'transform 0.2s ease',
                                }}>
                                    <Typography component="div" sx={{
                                        color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                                        fontWeight: 600,
                                        fontSize: 13,
                                        mb: 1,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 0.5
                                    }}>
                                        <Box sx={{
                                            width: 6,
                                            height: 6,
                                            borderRadius: '50%',
                                            background: '#0364ff'
                                        }} />
                                        Filtro
                                    </Typography>
                                    <SelectFilterTicket
                                        value={filtroGeneral}
                                        onChange={(e)=>setFiltroGeneral(e.value)}
                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={2}>
                                <Box sx={{
                                    width: '100%',
                                    transition: 'transform 0.2s ease',
                                }}>
                                    <Typography component="div" sx={{
                                        color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                                        fontWeight: 600,
                                        fontSize: 13,
                                        mb: 1,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 0.5
                                    }}>
                                        <Box sx={{
                                            width: 6,
                                            height: 6,
                                            borderRadius: '50%',
                                            background: '#4caf50'
                                        }} />
                                        Estado
                                    </Typography>
                                    <SelectFilterStageTicket
                                        isClearable
                                        value={filtroEstadoTk}
                                        onChange={(e)=>setFiltroEstadoTk(e?.value)}
                                    />
                                </Box>
                            </Grid>
                            { filtroGeneral === 'grupal' && (
                                <Grid item xs={12} sm={6} md={4} lg={2}>
                                    <Fade in={true} timeout={400}>
                                        <Box sx={{
                                            width: '100%',
                                            transition: 'transform 0.2s ease',
                                        }}>
                                            <Typography component="div" sx={{
                                                color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                                                fontWeight: 600,
                                                fontSize: 13,
                                                mb: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 0.5
                                            }}>
                                                <Box sx={{
                                                    width: 6,
                                                    height: 6,
                                                    borderRadius: '50%',
                                                    background: '#9c27b0'
                                                }} />
                                                Grupo
                                            </Typography>
                                            <SelectGruposUser
                                                isClearable
                                                value={selectGrupoId}
                                                onChange={(e)=>setSelectGrupoId(e?.value)}
                                            />
                                        </Box>
                                    </Fade>
                                </Grid>
                            )}
                            <Grid item xs={12} sm={6} md={4} lg={2}>
                                <Box sx={{
                                    width: '100%',
                                    transition: 'transform 0.2s ease',
                                }}>
                                    <Typography component="div" sx={{
                                        color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                                        fontWeight: 600,
                                        fontSize: 13,
                                        mb: 1,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 0.5
                                    }}>
                                        <Box sx={{
                                            width: 6,
                                            height: 6,
                                            borderRadius: '50%',
                                            background: '#ff9800'
                                        }} />
                                        SubTipo
                                    </Typography>
                                    <SelectSubTipoTicket
                                        isClearable
                                        value={selectSubTipoId}
                                        onChange={(e)=>setSelectSubTipoId(e?.value)}
                                        filterActivos={selectSubTipoArr}
                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={2}>
                                <Box sx={{
                                    width: '100%',
                                    transition: 'transform 0.2s ease',
                                }}>
                                    <Typography component="div" sx={{
                                        color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                                        fontWeight: 600,
                                        fontSize: 13,
                                        mb: 1,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 0.5
                                    }}>
                                        <Box sx={{
                                            width: 6,
                                            height: 6,
                                            borderRadius: '50%',
                                            background: '#f44336'
                                        }} />
                                        Vencimiento
                                    </Typography>
                                    <SelectEstadoVencimiento
                                        isClearable
                                        value={selectVencido}
                                        onChange={(e)=>setSelectVencido(e?.value)}
                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={2}>
                                <Box sx={{
                                    width: '100%',
                                    transition: 'transform 0.2s ease',
                                }}>
                                    <Typography component="div" sx={{
                                        color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                                        fontWeight: 600,
                                        fontSize: 13,
                                        mb: 1,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 0.5
                                    }}>
                                        <Box sx={{
                                            width: 6,
                                            height: 6,
                                            borderRadius: '50%',
                                            background: '#00bcd4'
                                        }} />
                                        Estado Softland
                                    </Typography>
                                    <SelectEstadoSoftland
                                        isClearable
                                        value={selectEstadoSoftland}
                                        onChange={(e)=>setSelectEstadoSoftland(e?.value)}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
                <Grid item xs={12} mt={2} sx={{marginBottom: 15}}>
                    <Card sx={{
                        background: isDarkMode ? '#1F2A40' : '#fff',
                        borderRadius: '16px',
                        boxShadow: isDarkMode 
                            ? '0 4px 20px rgba(0,0,0,0.3)'
                            : '0 4px 20px rgba(0,0,0,0.06)',
                        border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e0e0e0'
                    }}>
                        <Grid container>
                            <Grid item xs={10} sm={10} p={1}>
                                <TextField
                                    focused
                                    value={textSearch}
                                    autoComplete='off'
                                    onChange={(e)=>inSearchText(e.target.value)}
                                    InputProps={{
                                        type: 'search',
                                        startAdornment:(
                                            <SearchIcon sx={{color: isDarkMode ? '#b0bec5' : '#2c3e50'}} size={20} />
                                        ),
                                    }}
                                    sx={styleInput}
                                />
                            </Grid>
                            <Grid item xs={12} sm={2} display='flex' alignItems='center' justifyContent='center' p={1}>
                                <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#2c3e50', fontWeight: 'bold'}}>{`${ticketsView?.length || '0'} resultados`}</Typography>
                            </Grid>
                        </Grid>
                        <Divider sx={{background: isDarkMode ? '#3d4a62' : '#e0e0e0'}} />
                        <Grid container>
                            <Grid item xs={8} sm={10} p={1.5}>
                                <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#2c3e50', fontWeight: 'bold', ml:10}}>Ticket</Typography>
                            </Grid>
                            <Grid item xs={2} sm={2} display='flex' alignItems='center'>
                                <Divider orientation='vertical' sx={{background: isDarkMode ? '#3d4a62' : '#e0e0e0'}} />
                                <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#2c3e50', fontWeight: 'bold', textAlign: 'center', ml:4}}>Estado</Typography>
                            </Grid>
                        </Grid>
                        <Divider sx={{background: isDarkMode ? '#3d4a62' : '#e0e0e0'}} />
                        <Box mb={5}>
                            {(isLoading || isInitialLoad) ? (
                                <Fade in={true} timeout={600}>
                                    <Box sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        minHeight: '300px',
                                        flexDirection: 'column',
                                        gap: 3,
                                        position: 'relative',
                                        '&::before': {
                                            content: '""',
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            width: '250px',
                                            height: '250px',
                                            background: 'radial-gradient(circle, rgba(3,100,255,0.05) 0%, transparent 70%)',
                                            borderRadius: '50%',
                                            animation: 'ripple 3s ease-out infinite',
                                            '@keyframes ripple': {
                                                '0%': {
                                                    transform: 'translate(-50%, -50%) scale(0.8)',
                                                    opacity: 0
                                                },
                                                '50%': {
                                                    opacity: 0.3
                                                },
                                                '100%': {
                                                    transform: 'translate(-50%, -50%) scale(1.5)',
                                                    opacity: 0
                                                }
                                            }
                                        }
                                    }}>
                                        <Box sx={{
                                            position: 'relative',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: 2,
                                            background: isDarkMode 
                                                ? 'linear-gradient(135deg, #1F2A40 0%, #2d3a52 100%)'
                                                : 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                                            borderRadius: '20px',
                                            padding: '40px 50px',
                                            boxShadow: isDarkMode 
                                                ? '0 10px 40px rgba(0,0,0,0.4), 0 2px 8px rgba(0,0,0,0.2)'
                                                : '0 10px 40px rgba(0,0,0,0.08), 0 2px 8px rgba(0,0,0,0.04)',
                                            animation: 'float 3s ease-in-out infinite',
                                            '@keyframes float': {
                                                '0%, 100%': {
                                                    transform: 'translateY(0px)',
                                                    boxShadow: isDarkMode 
                                                        ? '0 10px 40px rgba(0,0,0,0.4), 0 2px 8px rgba(0,0,0,0.2)'
                                                        : '0 10px 40px rgba(0,0,0,0.08), 0 2px 8px rgba(0,0,0,0.04)'
                                                },
                                                '50%': {
                                                    transform: 'translateY(-10px)',
                                                    boxShadow: isDarkMode 
                                                        ? '0 15px 50px rgba(0,0,0,0.5), 0 5px 15px rgba(0,0,0,0.3)'
                                                        : '0 15px 50px rgba(0,0,0,0.12), 0 5px 15px rgba(0,0,0,0.06)'
                                                }
                                            }
                                        }}>
                                            <Box sx={{
                                                position: 'absolute',
                                                top: -20,
                                                right: -20,
                                                width: '100px',
                                                height: '100px',
                                                background: 'linear-gradient(135deg, #0364ff15 0%, #4a90e215 100%)',
                                                borderRadius: '50%',
                                                animation: 'rotate 20s linear infinite',
                                                '@keyframes rotate': {
                                                    '0%': { transform: 'rotate(0deg)' },
                                                    '100%': { transform: 'rotate(360deg)' }
                                                }
                                            }} />
                                            <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                                                <CircularProgress
                                                    size={70}
                                                    thickness={3}
                                                    sx={{
                                                        color: '#0364ff',
                                                        animation: 'spin 1.5s linear infinite',
                                                        '@keyframes spin': {
                                                            '0%': { transform: 'rotate(0deg)' },
                                                            '100%': { transform: 'rotate(360deg)' }
                                                        }
                                                    }}
                                                />
                                                <Box sx={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    width: '50px',
                                                    height: '50px',
                                                    borderRadius: '50%',
                                                    background: 'linear-gradient(135deg, #0364ff 0%, #4a90e2 100%)',
                                                    animation: 'pulse-glow 2s ease-in-out infinite',
                                                    '@keyframes pulse-glow': {
                                                        '0%, 100%': {
                                                            opacity: 0.2,
                                                            transform: 'translate(-50%, -50%) scale(0.8)'
                                                        },
                                                        '50%': {
                                                            opacity: 0.4,
                                                            transform: 'translate(-50%, -50%) scale(1)'
                                                        }
                                                    }
                                                }} />
                                            </Box>
                                            <Box sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                gap: 0.5,
                                                animation: 'fadeInUp 0.8s ease-out',
                                                '@keyframes fadeInUp': {
                                                    '0%': {
                                                        opacity: 0,
                                                        transform: 'translateY(20px)'
                                                    },
                                                    '100%': {
                                                        opacity: 1,
                                                        transform: 'translateY(0)'
                                                    }
                                                }
                                            }}>
                                                <Typography sx={{
                                                    color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                                                    fontSize: 18,
                                                    fontWeight: 700,
                                                    letterSpacing: '0.5px',
                                                    textAlign: 'center'
                                                }}>
                                                    Cargando tickets
                                                </Typography>
                                                <Typography sx={{
                                                    color: isDarkMode ? '#b0bec5' : '#7f8c8d',
                                                    fontSize: 14,
                                                    fontWeight: 500,
                                                    textAlign: 'center',
                                                    animation: 'dots 1.5s steps(4, end) infinite',
                                                    '&::after': {
                                                        content: '"..."',
                                                        display: 'inline-block',
                                                        width: '20px',
                                                        textAlign: 'left',
                                                        animation: 'dots 1.5s steps(4, end) infinite'
                                                    },
                                                    '@keyframes dots': {
                                                        '0%, 20%': { content: '"."' },
                                                        '40%': { content: '".."' },
                                                        '60%, 100%': { content: '"..."' }
                                                    }
                                                }}>
                                                    Por favor espera
                                                </Typography>
                                            </Box>
                                            <Box sx={{
                                                width: '180px',
                                                height: '3px',
                                                background: isDarkMode ? '#3d4a62' : '#e0e0e0',
                                                borderRadius: '10px',
                                                overflow: 'hidden',
                                                position: 'relative',
                                                mt: 1
                                            }}>
                                                <Box sx={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    height: '100%',
                                                    width: '50%',
                                                    background: 'linear-gradient(90deg, transparent, #0364ff, transparent)',
                                                    animation: 'slide 1.5s ease-in-out infinite',
                                                    '@keyframes slide': {
                                                        '0%': { transform: 'translateX(-100%)' },
                                                        '100%': { transform: 'translateX(300%)' }
                                                    }
                                                }} />
                                            </Box>
                                        </Box>
                                    </Box>
                                </Fade>
                            ) : ticketsView?.length > 0 ? (
                                <>
                                    {ticketsDisplayed.map((tkv, index)=> (
                                        <Fade
                                            key={tkv?.id_uxt}
                                            in={true}
                                            timeout={300}
                                            style={{ transitionDelay: `${Math.min(index * 30, 300)}ms` }}
                                        >
                                            <Box>
                                                <CardViewTicket item={tkv} isDarkMode={isDarkMode} />
                                            </Box>
                                        </Fade>
                                    ))}
                                    {displayCount < ticketsView.length && (
                                        <Grow in={true} timeout={500}>
                                            <Box 
                                                ref={observerTarget}
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    py: 4,
                                                    position: 'relative',
                                                    '&::before': {
                                                        content: '""',
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: '50%',
                                                        transform: 'translateX(-50%)',
                                                        width: '80%',
                                                        height: '1px',
                                                        background: isDarkMode 
                                                            ? 'linear-gradient(90deg, transparent, #3d4a62 50%, transparent)'
                                                            : 'linear-gradient(90deg, transparent, #e0e0e0 50%, transparent)',
                                                    }
                                                }}
                                            >
                                                <Box sx={{
                                                    position: 'relative',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 2,
                                                    background: isDarkMode 
                                                        ? 'linear-gradient(135deg, #1F2A40 0%, #2d3a52 100%)'
                                                        : 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                                                    borderRadius: '50px',
                                                    px: 3,
                                                    py: 1.5,
                                                    boxShadow: isDarkMode 
                                                        ? '0 4px 12px rgba(0,0,0,0.3)'
                                                        : '0 4px 12px rgba(0,0,0,0.08)',
                                                    animation: 'pulse 2s ease-in-out infinite',
                                                    '@keyframes pulse': {
                                                        '0%, 100%': {
                                                            transform: 'scale(1)',
                                                            boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
                                                        },
                                                        '50%': {
                                                            transform: 'scale(1.02)',
                                                            boxShadow: '0 6px 16px rgba(0,0,0,0.12)'
                                                        }
                                                    }
                                                }}>
                                                    <CircularProgress
                                                        size={24}
                                                        thickness={4}
                                                        sx={{
                                                            color: '#0364ff',
                                                            animation: 'spin 1s linear infinite',
                                                            '@keyframes spin': {
                                                                '0%': { transform: 'rotate(0deg)' },
                                                                '100%': { transform: 'rotate(360deg)' }
                                                            }
                                                        }}
                                                    />
                                                    <Box>
                                                        <Typography sx={{
                                                            color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                                                            fontSize: 13,
                                                            fontWeight: 600,
                                                            letterSpacing: '0.3px'
                                                        }}>
                                                            Cargando más tickets...
                                                        </Typography>
                                                        <Typography sx={{
                                                            color: isDarkMode ? '#b0bec5' : '#7f8c8d',
                                                            fontSize: 11,
                                                            fontWeight: 500,
                                                            mt: 0.3
                                                        }}>
                                                            {ticketsDisplayed.length} de {ticketsView.length} mostrados
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                                <Box sx={{
                                                    mt: 2,
                                                    width: '200px',
                                                    height: '4px',
                                                    background: isDarkMode ? '#3d4a62' : '#e0e0e0',
                                                    borderRadius: '10px',
                                                    overflow: 'hidden',
                                                    position: 'relative'
                                                }}>
                                                    <Box sx={{
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0,
                                                        height: '100%',
                                                        width: `${(ticketsDisplayed.length / ticketsView.length) * 100}%`,
                                                        background: 'linear-gradient(90deg, #0364ff 0%, #4a90e2 100%)',
                                                        borderRadius: '10px',
                                                        transition: 'width 0.5s ease',
                                                        boxShadow: '0 0 10px rgba(3, 100, 255, 0.3)'
                                                    }} />
                                                </Box>
                                                <Box sx={{
                                                    mt: 2,
                                                    animation: 'bounce 2s ease-in-out infinite',
                                                    '@keyframes bounce': {
                                                        '0%, 100%': { transform: 'translateY(0px)' },
                                                        '50%': { transform: 'translateY(-10px)' }
                                                    }
                                                }}>
                                                    <ExpandMoreIcon sx={{
                                                        fontSize: 28,
                                                        color: '#0364ff',
                                                        opacity: 0.6
                                                    }} />
                                                </Box>
                                            </Box>
                                        </Grow>
                                    )}
                                    {displayCount >= ticketsView.length && ticketsView.length > 20 && (
                                        <Fade in={true} timeout={800}>
                                            <Box sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                py: 3,
                                                gap: 1
                                            }}>
                                                <Box sx={{
                                                    background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)',
                                                    borderRadius: '25px',
                                                    px: 3,
                                                    py: 1.5,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 1.5,
                                                    boxShadow: '0 2px 8px rgba(76, 175, 80, 0.2)',
                                                    border: '1px solid #a5d6a7'
                                                }}>
                                                    <Box sx={{
                                                        width: 24,
                                                        height: 24,
                                                        borderRadius: '50%',
                                                        background: '#4caf50',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        animation: 'checkmark 0.6s ease',
                                                        '@keyframes checkmark': {
                                                            '0%': { transform: 'scale(0) rotate(0deg)', opacity: 0 },
                                                            '50%': { transform: 'scale(1.2) rotate(180deg)' },
                                                            '100%': { transform: 'scale(1) rotate(360deg)', opacity: 1 }
                                                        }
                                                    }}>
                                                        <Typography sx={{color: '#fff', fontSize: 14, fontWeight: 'bold'}}>✓</Typography>
                                                    </Box>
                                                    <Box>
                                                        <Typography sx={{
                                                            color: '#2e7d32',
                                                            fontSize: 13,
                                                            fontWeight: 600,
                                                            letterSpacing: '0.2px'
                                                        }}>
                                                            Todos los tickets cargados
                                                        </Typography>
                                                        <Typography sx={{
                                                            color: '#558b2f',
                                                            fontSize: 11,
                                                            fontWeight: 500,
                                                            mt: 0.2
                                                        }}>
                                                            {ticketsView.length} tickets en total
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Fade>
                                    )}
                                </>
                            ) : (
                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    minHeight: '300px',
                                    flexDirection: 'column'
                                }}>
                                    <Typography sx={{color: isDarkMode ? '#b0bec5' : '#6b788e', fontSize: 18, fontWeight: 'bold'}}>
                                        No se encontraron tickets
                                    </Typography>
                                    <Typography sx={{color: isDarkMode ? '#7f8c8d' : '#9ca3af', fontSize: 14, mt: 1}}>
                                        Intenta cambiar los filtros o crear uno nuevo
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    )
}
const mapStateToProps = (state) => ({
    ticketrefresh: state.ticketrefresh
})

const mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(TablaTicketScreen)